//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientDataInfoApi, contractDetailApi } from '@/api/enterprise';
export default {
  name: 'EditContract',
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    contractInfo: function contractInfo() {
      return import('./contractInfo');
    },
    contractRenew: function contractRenew() {
      return import('./contractRenew');
    },
    contractInvoice: function contractInvoice() {
      return import('./contractInvoice');
    },
    contractRemind: function contractRemind() {
      return import('./contractRemind');
    },
    contractPayment: function contractPayment() {
      return import('./contractPayment');
    },
    file: function file() {
      return import('./file');
    },
    ueditorFrom: function ueditorFrom() {
      return import('@/components/form-common/oa-wangeditor');
    },
    editCustomer: function editCustomer() {
      return import('@/views/customer/list/components/editCustomer');
    }
  },
  data: function data() {
    return {
      drawer: false,
      direction: 'rtl',
      record: {
        info: ''
      },
      cid: 0,
      activeColor: '',
      newForm: {},
      contractInvoice: 'is_contract',
      autosize: {
        minRows: 5,
        maxRows: 10
      },
      remindAutosize: {
        minRows: 2,
        maxRows: 4
      },
      dataInfo: [],
      tabPosition: 'top',
      tabIndex: '1',
      tabNumber: 1,
      tabData: [{
        value: '1',
        label: this.$t('setting.info.essentialinformation')
      }, {
        value: '2',
        label: '账目记录'
      },
      // { value: '6', label: '合同续费' },
      {
        value: '3',
        label: this.$t('customer.paymentreminder')
      }, {
        value: '4',
        label: this.$t('customer.invoice')
      }, {
        value: '5',
        label: '记录'
      }],
      configContract: {},
      formBoxConfig: {},
      loading: false
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.tabData = [{
        value: '1',
        label: this.$t('setting.info.essentialinformation')
      }, {
        value: '2',
        label: this.$t('customer.paymentrecord')
      }, {
        value: '3',
        label: this.$t('customer.paymentreminder')
      }, {
        value: '4',
        label: this.$t('customer.invoice')
      }, {
        value: '5',
        label: this.$t('customer.annexrelated')
      }];
    },
    handleClose: function handleClose() {
      this.drawer = false;
    },
    // 获取合同详情
    getDetails: function getDetails(id) {
      var _this = this;
      contractDetailApi(id).then(function (res) {
        _this.dataInfo = res.data;
      });
    },
    // 合同状态
    getStatus: function getStatus(val) {
      var statusData = {
        0: '未开始',
        1: '进行中',
        2: '已结束',
        3: '异常合同'
      };
      var colorData = {
        0: '#00c050',
        1: '#1890ff',
        2: '#999999',
        3: '#ed4014'
      };
      this.activeColor = colorData[val];
      return statusData[val];
    },
    // 数组转成字符串
    getValue: function getValue(val) {
      var str = '';
      if (val == '') {
        str = '--';
      } else if (Array.isArray(val)) {
        str = val.toString();
      } else {
        str = val;
      }
      return str || '--';
    },
    openBox: function openBox(row) {
      var _this2 = this;
      this.cid = row.cid;
      this.drawer = true;
      if (this.tabNumber == 2) {
        setTimeout(function () {
          _this2.$refs.contractPayment.getTableData(row.id);
          _this2.$refs.contractPayment.getConfigApprove(6);
          _this2.$refs.contractPayment.getConfigApprove(7);
          _this2.$refs.contractPayment.getConfigApprove(8);
        }, 300);
      }
      if (row.cid) {
        this.getDetails(row.cid);
      }
    },
    handleClick: function handleClick(event) {
      var _this3 = this;
      this.tabNumber = Number(event.name);
      if (this.tabNumber === 2) {
        this.$refs.contractPayment.getTableData(this.cid);
        this.$refs.contractPayment.getConfigApprove(6);
        this.$refs.contractPayment.getConfigApprove(7);
        this.$refs.contractPayment.getConfigApprove(8);
      } else if (this.tabNumber === 3) {
        this.$refs.contractRemind.getTableData();
      } else if (this.tabNumber === 4) {
        this.$refs.contractInvoice.getTableData();
      } else if (this.tabNumber === 5) {
        setTimeout(function () {
          _this3.$refs.file.getTableData();
        }, 500);
      } else if (this.tabNumber === 6) {
        this.$refs.contractRenew.getTableData();
      }
    },
    // 打开客户
    handleClient: function handleClient() {
      var _this4 = this;
      clientDataInfoApi(this.formData.data.contract_customer.id).then(function (res) {
        res.data.source = res.data.source.id;
        var newAddress = [];
        if (res.data.address) {
          res.data.address.map(function (item) {
            newAddress.push(item.label);
          });
          res.data.address = newAddress;
        }
        _this4.newForm = {
          title: _this4.$t('customer.editcustomer'),
          width: '1000px',
          data: res.data,
          isClient: true,
          edit: true
        };
        _this4.$refs.editCustomer.tabIndex = '1';
        _this4.$refs.editCustomer.tabNumber = 1;
        _this4.$refs.editCustomer.openBox();
      });
    },
    handleContractInfo: function handleContractInfo(data) {
      this.loading = data.loading;
      if (data.success === 1) {
        this.formData.editIndex = data.editIndex;
        this.formData.data.title = data.title;
        this.formData.data.price = data.price;
        this.$emit('isOk');
      }
    },
    handleInvoice: function handleInvoice() {
      this.$emit('isOk');
    },
    handleConfirm: function handleConfirm() {
      this.$refs.contractInfo.handleConfirm();
    }
  }
};